import { useCallback, useEffect, useState } from "react";
import { useDataProvider, useNotify, useRedirect } from "react-admin";
import { MenuTreeEdit2 } from "./components/menu-tree-edit-2";
import { MenuTreeMassage } from "./components/menu-tree-massage";

import "./custom.css";

// popup
// import Popup from "reactjs-popup";
import queryString from "query-string";
import "reactjs-popup/dist/index.css";

// import dataProvider from "../../dataProvider";

// const customButtonStyle = {
//   backgroundColor: "transparent",
//   border: "1px solid grey",
//   margin: "10px",
// };

export const MenuTreeCreate = (props) => {
  const dataProvider = useDataProvider();
  const redirectTo = useRedirect();
  const notify = useNotify();

  // constructor
  const [resp, setResp] = useState(false);

  useEffect(() => {
    const parsed = queryString.parse(props.location.search);

    if (parsed && parsed.source) {
      // if (source) {
      const j = JSON.parse(parsed.source);
      setResp(j);
    } else {
      setResp({
        menu_tree: [],
        start_time: "",
        description: "description here",
      });
    }
  }, []);

  // call POST API
  const saveMenuTreeCallback = useCallback((params) => {
    const rows = params.rows;
    const startTime = params.startTime;
    const description = params.description;
    const profileClass = resp.profile_class;

    // massage rows
    const menuTree = MenuTreeMassage(rows);

    const param = {
      menu_tree: menuTree,
      start_time: startTime,
      description: description,
      profile_class: profileClass,
    };

    dataProvider
      .postMenuTree(param)
      .then(() => {
        notify("Create Menu tree is Successful", "success");
        redirectTo("/menu-tree");
      })
      .catch((e) => {
        console.log(e);
        notify(e.message.toString(), "warning");
      });
  });

  return resp.menu_tree ? <MenuTreeEdit2 {...props} mode="create" rows={JSON.parse(JSON.stringify(resp.menu_tree))} start_time={resp.start_time} description={resp.description} saveMenuTreeCallback={saveMenuTreeCallback} /> : <></>;
};
